"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriverLicenceSelect = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const types_1 = require("@src/types");
const react_1 = __importDefault(require("react"));
const A_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/A.svg"));
const A1_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/A1.svg"));
const A2_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/A2.svg"));
const AM_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/AM.svg"));
const B_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/B.svg"));
const B1_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/B1.svg"));
const BE_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/BE.svg"));
const C_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/C.svg"));
const C1_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/C1.svg"));
const C1E_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/C1E.svg"));
const CE_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/CE.svg"));
const D_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/D.svg"));
const D1_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/D1.svg"));
const D1E_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/D1E.svg"));
const DE_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/DE.svg"));
const T_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/T.svg"));
const styled_components_1 = __importDefault(require("styled-components"));
const { Option } = elements_1.Select;
const driverLicenceIcons = {
    AM: AM_svg_1.default,
    A1: A1_svg_1.default,
    A2: A2_svg_1.default,
    A: A_svg_1.default,
    B1: B1_svg_1.default,
    B: B_svg_1.default,
    BE: BE_svg_1.default,
    C1: C1_svg_1.default,
    C1E: C1E_svg_1.default,
    C: C_svg_1.default,
    CE: CE_svg_1.default,
    D1: D1_svg_1.default,
    D1E: D1E_svg_1.default,
    D: D_svg_1.default,
    DE: DE_svg_1.default,
    T: T_svg_1.default,
};
const SvgWrapper = styled_components_1.default.div `
	display: flex;
	flex-direction: row;
	margin-left: 0.25rem;

	svg {
		width: 3rem;
		height: 1.5rem;
	}
`;
const DriverLicenceSelect = ({ onChange, value, defaultValue, isNotSelectedLicence, ...otherProps }) => {
    const driverLicences = Object.values(types_1.DriverLicence);
    return ((0, jsx_runtime_1.jsx)(elements_1.Select, { onChange: onChange, value: value, defaultValue: defaultValue, ...otherProps, children: driverLicences
            .filter(licence => (isNotSelectedLicence ? isNotSelectedLicence(licence) : licence))
            .map(driverLicence => {
            const Icon = driverLicenceIcons[driverLicence];
            return ((0, jsx_runtime_1.jsx)(Option, { value: driverLicence, children: (0, jsx_runtime_1.jsxs)("div", { className: "flex-row justify-space-between width-100 align-center", children: [driverLicence, (0, jsx_runtime_1.jsx)(SvgWrapper, { children: (0, jsx_runtime_1.jsx)(Icon, {}) })] }) }, driverLicence));
        }) }));
};
exports.DriverLicenceSelect = DriverLicenceSelect;
